import { render, staticRenderFns } from "./PuzzleTemplatePage.vue?vue&type=template&id=cbaed014&"
import script from "./PuzzleTemplatePage.vue?vue&type=script&lang=js&"
export * from "./PuzzleTemplatePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports